import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BusinessCard from '../components/BusinessCard';
import { getTopic } from '../api';

export default function TopicPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getTopic(slug)
      .then(r => setData(r.data))
      .catch(() => setError('Argomento non trovato'))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div style={{ backgroundColor: 'var(--mi-bg)' }}>
      <Header />
      <div className="mi-container py-10">

        {loading && (
          <div className="space-y-4">
            <div className="skeleton-shimmer h-10 rounded w-1/3" />
            <div className="skeleton-shimmer h-4 rounded w-1/2" />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
              {[1,2,3,4,5,6].map(i => (
                <div key={i} className="rounded-2xl overflow-hidden border" style={{ borderColor: 'var(--mi-border)' }}>
                  <div className="skeleton-shimmer" style={{ paddingTop: '56.25%' }} />
                  <div className="p-4 space-y-2">
                    <div className="skeleton-shimmer h-5 rounded w-3/4" />
                    <div className="skeleton-shimmer h-3 rounded w-1/2" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {error && (
          <div className="text-center py-20">
            <p className="font-display text-2xl mb-2" style={{ color: 'var(--mi-fg)' }}>{error}</p>
            <Link to="/attivita" className="text-sm hover:underline" style={{ color: 'var(--mi-accent)' }}>Torna all'archivio</Link>
          </div>
        )}

        {!loading && !error && data && (
          <>
            {/* Header */}
            <div
              className="rounded-2xl p-8 mb-8 border"
              style={{ background: 'linear-gradient(135deg, var(--mi-muted) 0%, #FAFAF8 100%)', borderColor: 'var(--mi-border)' }}
            >
              <span
                className="inline-block text-xs uppercase tracking-widest px-3 py-1 rounded-full border mb-3"
                style={{ borderColor: 'var(--mi-accent)', color: 'var(--mi-accent)', backgroundColor: 'rgba(200,169,110,0.08)' }}
              >
                Argomento
              </span>
              <h1 className="font-display text-4xl md:text-5xl tracking-tight" style={{ color: 'var(--mi-fg)' }}>
                {data.nome}
              </h1>
              <p className="mt-3 text-base" style={{ color: 'var(--mi-text)' }}>
                {data.count} attività legate a questo argomento
              </p>
            </div>

            {/* Grid */}
            {data.businesses?.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {data.businesses.map((b) => (
                  <BusinessCard key={b._id} business={b} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p style={{ color: 'var(--mi-text)' }}>Nessuna attività trovata per questo argomento.</p>
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
